var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManualCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2686 11.2465H25.0132C25.4882 11.2465 25.8737 11.632 25.8737 12.107V21.5726C25.8737 22.0476 25.4882 22.4331 25.0132 22.4331H6.94254C6.46754 22.4331 6.08203 22.0476 6.08203 21.5726V12.107C6.08203 11.632 6.46754 11.2465 6.94254 11.2465H9.09381M17.7023 17.27H23.2956M15.1208 19.8516H23.2956M8.79607 16.5386L8.66355 19.4213L11.0477 17.7949L16.7076 7.64784C16.8229 7.44017 16.7483 7.17801 16.5406 7.0627L15.0382 6.22456C14.9384 6.16892 14.8208 6.15515 14.7106 6.18613C14.6011 6.21711 14.5075 6.29054 14.4519 6.39035L8.79607 16.5386Z",
    stroke: "black",
    strokeWidth: 1.31579,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualCheckIcon);
export default __webpack_public_path__ + "static/media/ManualCheckIcon.0c4c9b156199f3add8aa9ae198855256.svg";
export { ForwardRef as ReactComponent };